/*
 * @Author: your name
 * @Date: 2021-07-13 14:49:11
 * @LastEditTime: 2023-01-13 11:41:29
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\router\center-business\stock.js
 */
/*
 * 库存管理
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
// import Test0Empty from '@/views/test/empty.vue';
export default {
  path: 'stock',
  name: 'BusinessStock',
  component: EmptyRouterAlive,
  meta: {
    title: '库存管理',
  },
  children: [
    /**  **** 库存查询 Search  ****  */
    {
      path: 'search',
      name: 'BusinessStockSearch',
      component: EmptyRouter,
      redirect: 'search/sku',
      meta: {
        title: '库存查询',
      },
      children: [
        {
          path: 'sku',
          name: 'BusinessStockSearch',
          component: () => import('@/views/center-business/stock/search/index.vue'),
          meta: {
            title: '库存查询',
            isCache: true
          },
          hidden: true,
        },
      ],
    },
    /**  **** 库存变动  ****  */
    {
      path: 'movement',
      name: 'BusinessStockMovement',
      component: EmptyRouter,
      redirect: 'movement/index',
      meta: {
        title: '库存变动',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessStockMovement',
          component: () => import('@/views/center-business/stock/movement/index.vue'),
          meta: {
            title: '库存变动',
            isCache: true
          },
        },
      ],
    },
    /**  **** 库存变动查询 Change  ****  */
    {
      path: 'change',
      name: 'BusinessStockChange',
      component: EmptyRouter,
      redirect: 'change/index',
      meta: {
        title: '库存变动查询',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessStockChange',
          component: () => import('@/views/center-business/stock/change/index.vue'),
          meta: {
            title: '库存变动查询',
            isCache: true
          },
        },
      ],
    },
    /**  **** 批次库存查询  BatchInventoryQuery ===========> CSG  ****  */    {
      path: 'csg/BatchInventoryQuery',
      name: 'BusinessBatchInventoryQuery',
      component: EmptyRouter,
      redirect: 'csg/BatchInventoryQuery/index',
      meta: {
        title: '批次库存查询',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBatchInventoryQuery',
          component: () => import('@/views/center-business/stock/csg/BatchInventoryQuery/index.vue'),
          meta: {
            title: '批次库存查询',
            isCache: true
          },
          hidden: true,
        },
      ],
    },
    /**  **** 批次库存发货记录 BatchInventoryQuery ===========> CSG  ****  */    {
      path: 'csg/BatchShipmentecord',
      name: 'BusinessBatchShipmentecord',
      component: EmptyRouter,
      redirect: 'csg/BatchShipmentecord/index',
      meta: {
        title: '批次库存发货记录',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessBatchShipmentecord',
          component: () => import('@/views/center-business/stock/csg/BatchShipmentecord/index.vue'),
          meta: {
            title: '批次库存发货记录',
            isCache: true
          },
          hidden: true,
        },
      ],
    },
    {
      path: 'StorageTransactionReport',
      name: 'BusinessStorageTransactionReport',
      component: EmptyRouter,
      redirect: 'StorageTransactionReport',
      meta: {
        title: '存储记录',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessStorageTransactionReport',
          component: () => import('@/views/center-business/stock/csg/StorageTransactionReport'),
          meta: {
            title: '存储记录',
            isCache: true
          },
          hidden: true,
        },
      ],
    },
    {
      path: 'csg/search',
      name: 'BusinessStockSearchCSG',
      component: EmptyRouter,
      redirect: 'csg/search/index',
      meta: {
        title: '库存查询',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessStockSearchCSG',
          component: () => import('@/views/center-business/stock/csg/search/index.vue'),
          meta: {
            title: '库存查询',
            isCache: true
          },
          hidden: true,
        },
      ],
    },
    /**  **** 库存变动查询 Change ===========> CSG  ****  */
    {
      path: 'csg/change',
      name: 'BusinessStockChangeCSG',
      component: EmptyRouter,
      redirect: 'csg/change/index',
      meta: {
        title: '库存变动查询',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessStockChangeCSG',
          component: () => import('@/views/center-business/stock/csg/change/index.vue'),
          meta: {
            title: '库存变动查询',
            isCache: true
          },
        },
      ],
    },
    /**  **** 用户板数  CSG  ****  */
    {
      path: 'csg/user',
      name: 'BusinessStockUserCsg',
      component: EmptyRouter,
      redirect: 'csg/user/index',
      meta: {
        title: '用户板数',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessStockUserCsg',
          component: () => import('@/views/center-business/stock/csg/user/index.vue'),
          meta: {
            title: '用户板数',
            isCache: true
          },
          hidden: true,
        },
      ],
    },
    /** 入库管理 **/
    {
      path: 'entry',
      name: 'BusinessStockEntry',
      component: EmptyRouter,
      redirect: 'entry/inform',
      meta: {
        title: '入库管理',
      },
      children: [
        {
          path: 'inform',
          name: 'BusinessStockEntryInformIndex',
          component: () => import('@/views/center-business/stock/entry/inform/index.vue'),
          meta: {
            title: '入库通知单',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'inform/view',
          name: 'BusinessStockEntryInformView',
          component: () => import('@/views/center-business/stock/entry/inform/view.vue'),
          meta: {
            title: '入库通知单详情',
          },
          hidden: true,
        },
        {
          path: 'result',
          name: 'BusinessStockEntryResultIndex',
          component: () => import('@/views/center-business/stock/entry/result/index.vue'),
          meta: {
            title: '入库结果单',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'result/view',
          name: 'BusinessStockEntryResultView',
          component: () => import('@/views/center-business/stock/entry/result/view.vue'),
          meta: {
            title: '入库结果单详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockEntryInformIndex_Log',
          meta: {
            title: '日志',
          },
          hidden: true,
        },
      ],
    },
    /** 入库管理end */
    /** 出库管理 **/
    {
      path: 'delivery',
      name: 'BusinessStockDelivery',
      component: EmptyRouter,
      redirect: 'delivery/inform',
      meta: {
        title: '出库管理',
      },
      children: [
        {
          path: 'inform',
          name: 'BusinessStockDeliveryInformIndex',
          component: () => import('@/views/center-business/stock/delivery/inform/index.vue'),
          meta: {
            title: '出库通知单',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'inform/view',
          name: 'BusinessStockDeliveryInformView',
          component: () => import('@/views/center-business/stock/delivery/inform/view.vue'),
          meta: {
            title: '出库通知单详情',
          },
          hidden: true,
        },
        {
          path: 'result',
          name: 'BusinessStockDeliveryResultIndex',
          component: () => import('@/views/center-business/stock/delivery/result/index.vue'),
          meta: {
            title: '出库结果单',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'result/view',
          name: 'BusinessStockDeliveryResultView',
          component: () => import('@/views/center-business/stock/delivery/result/view.vue'),
          meta: {
            title: '出库结果单详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockDeliveryInformIndex_Log',
          meta: {
            title: '日志',
          },
          hidden: true,
        },
      ],
    },
    /** 出库管理end */
    {
      path: 'consign',
      name: 'BusinessStockConsign',
      redirect: 'consign/intimidate',
      component: EmptyRouter,
      meta: {
        title: '打单发货',
      },
      children: [
        {
          path: 'intimidate',
          name: 'BusinessStockConsignIntimidate',
          component: () => import('@/views/center-business/stock/consign/intimidate'),
          meta: {
            title: '打单发货',
          },
          permissionType: 'tab',
        },
        {
          path: 'check',
          name: 'BusinessStockConsignCheck',
          component: () => import('@/views/center-business/stock/consign/check'),
          meta: {
            title: '检验发货',
            isCache: true,
          },
          permissionType: 'tab',
        },
      ],
    },
    // #ifndef OPEN-SOURCE
    /**  **** 调拨管理 Transfer  ****  */
    {
      path: 'transfer',
      name: 'BusinessStockTransfer',
      component: EmptyRouter,
      redirect: 'transfer/logic',
      meta: {
        title: '调拨管理',
      },
      children: [
        // 逻辑仓调拨
        {
          path: 'logic',
          name: 'BusinessStockTransferLogicIndex',
          component: () => import('@/views/center-business/stock/transfer/logic/index'),
          meta: {
            title: '逻辑仓调拨',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'logic/add',
          name: 'BusinessStockTransferLogicAdd',
          component: () => import('@/views/center-business/stock/transfer/logic/add'),
          meta: {
            title: '新建逻辑仓调拨',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'logic/edit',
          name: 'BusinessStockTransferLogicEdit',
          component: () => import('@/views/center-business/stock/transfer/logic/edit'),
          meta: {
            title: '编辑逻辑仓调拨',
          },
          hidden: true,
        },
        {
          path: 'logic/view',
          name: 'BusinessStockTransferLogicView',
          component: () => import('@/views/center-business/stock/transfer/logic/view'),
          meta: {
            title: '逻辑仓调拨详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockTransferLogicIndex_Reset',
          meta: {
            title: '重置-逻辑仓调拨',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockTransferLogicIndex_Execute1',
          meta: {
            title: '执行-逻辑仓调拨',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockTransferLogicIndex_Execute2',
          meta: {
            title: '再次执行-逻辑仓调拨',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockTransferLogicIndex_Cancel',
          meta: {
            title: '取消-逻辑仓调拨',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockTransferLogicIndex_Invalid',
          meta: {
            title: '作废-逻辑仓调拨',
          },
          hidden: true,
        },
        // 虚仓移仓
        {
          path: 'virtual',
          name: 'BusinessStockTransferVirtualIndex',
          component: () => import('@/views/center-business/stock/transfer/virtual/index'),
          meta: {
            title: '虚仓移仓',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'virtual/add',
          name: 'BusinessStockTransferVirtualAdd',
          component: () => import('@/views/center-business/stock/transfer/virtual/add'),
          meta: {
            title: '新建虚仓移仓',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'virtual/edit',
          name: 'BusinessStockTransferVirtualEdit',
          component: () => import('@/views/center-business/stock/transfer/virtual/edit'),
          meta: {
            title: '编辑虚仓移仓',
          },
          hidden: true,
        },
        {
          path: 'virtual/view',
          name: 'BusinessStockTransferVirtualView',
          component: () => import('@/views/center-business/stock/transfer/virtual/view'),
          meta: {
            title: '虚仓移仓详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockTransferVirtualIndex_Reset',
          meta: {
            title: '重置-虚仓移仓',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockTransferVirtualIndex_Execute1',
          meta: {
            title: '执行-虚仓移仓',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockTransferVirtualIndex_Execute2',
          meta: {
            title: '再次执行-虚仓移仓',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockTransferVirtualIndex_Cancel',
          meta: {
            title: '取消-虚仓移仓',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockTransferVirtualIndex_Invalid',
          meta: {
            title: '作废-虚仓移仓',
          },
          hidden: true,
        },
      ],
    },
    /** 调拨管理end */
    /** 预留锁定 */
    {
      path: 'lock',
      name: 'BusinessStockLock',
      component: EmptyRouter,
      redirect: 'lock/list',
      meta: {
        title: '预留锁定管理',
      },
      children: [
        {
          path: 'list',
          name: 'BusinessStockLock',
          component: () => import('@/views/center-business/stock/lock'),
          meta: {
            title: '预留锁定管理',
          },
        },
        {
          path: 'add',
          name: 'BusinessStockLockAdd',
          component: () => import('@/views/center-business/stock/lock/add'),
          meta: {
            title: '新建预留锁定单',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'view',
          name: 'BusinessStockLockView',
          component: () => import('@/views/center-business/stock/lock/view'),
          meta: {
            title: '预留锁定单详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockLockIndex_Status',
          meta: {
            title: '停用/启用-预留锁定管理',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockLockIndex_Abandon',
          meta: {
            title: '作废-预留锁定管理',
          },
          hidden: true,
        },
      ],
    },
    /** 预留锁定end */
    /**  **** 库存变动审核 verify  ****  */
    {
      path: 'verify',
      name: 'BusinessStockVerify',
      component: EmptyRouter,
      redirect: 'verify/logic',
      meta: {
        title: '库存变动审核',
      },
      children: [
        {
          path: 'logic',
          name: 'BusinessStockVerifyLogicIndex',
          component: () => import('@/views/center-business/stock/verify/logic/index'),
          meta: {
            title: '逻辑仓调拨审核',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'logic/view',
          name: 'BusinessStockVerifyLogicView',
          component: () => import('@/views/center-business/stock/verify/logic/view'),
          meta: {
            title: '逻辑仓调拨审核详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockVerifyLogicIndex_Pass',
          meta: {
            title: '审核通过-逻辑仓调拨审核',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockVerifyLogicIndex_Reject',
          meta: {
            title: '审核拒绝-逻辑仓调拨审核',
          },
          hidden: true,
        },
        {
          path: 'virtual',
          name: 'BusinessStockVerifyVirtualIndex',
          component: () => import('@/views/center-business/stock/verify/virtual/index'),
          meta: {
            title: '虚仓移仓审核',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'virtual/view',
          name: 'BusinessStockVerifyVirtualView',
          component: () => import('@/views/center-business/stock/verify/virtual/view'),
          meta: {
            title: '虚仓移仓审核详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockVerifyVirtualIndex_Pass',
          meta: {
            title: '审核通过-虚仓移仓审核',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockVerifyVirtualIndex_Reject',
          meta: {
            title: '审核拒绝-虚仓移仓审核',
          },
          hidden: true,
        },
        {
          path: 'lock',
          name: 'BusinessStockVerifyLockIndex',
          component: () => import('@/views/center-business/stock/verify/lock/index'),
          meta: {
            title: '库存预留审核',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'lock/view',
          name: 'BusinessStockVerifyLockView',
          component: () => import('@/views/center-business/stock/verify/lock/view'),
          meta: {
            title: '库存预留审核详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockVerifyLock_Pass',
          meta: {
            title: '审核通过-库存预留审核',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockVerifyLock_Reject',
          meta: {
            title: '审核拒绝-库存预留审核',
          },
          hidden: true,
        },
        {
          path: 'plan',
          name: 'BusinessStockVerifyPlanIndex',
          component: () => import('@/views/center-business/stock/verify/plan/index'),
          meta: {
            title: '分仓计划审核',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'plan/view',
          name: 'BusinessStockVerifyPlanView',
          component: () => import('@/views/center-business/stock/verify/plan/view'),
          meta: {
            title: '分仓计划审核详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockVerifyPlanIndex_Pass',
          meta: {
            title: '审核通过-分仓计划审核',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockVerifyPlanIndex_Reject',
          meta: {
            title: '审核拒绝-分仓计划审核',
          },
          hidden: true,
        },
      ],
    },
    /** 库存变动审核end */
    // {
    //   path: 'abnormal',
    //   name: 'BusinessStockAbnormal',
    //   component: EmptyRouter,
    //   redirect: 'abnormal/order',
    //   meta: {
    //     title: '异常库存管理',
    //   },
    //   children: [
    //     {
    //       path: 'order',
    //       name: 'BusinessStockAbnormalOrder',
    //       component: () => import('@/views/center-business/stock/abnormal/order'),
    //       meta: {
    //         title: '订单缺货',
    //       },
    //       permissionType: 'tab',
    //       hidden: true,
    //     },
    //     {
    //       path: 'warehouse',
    //       name: 'BusinessStockAbnormalWarehouse',
    //       component: () => import('@/views/center-business/stock/abnormal/warehouse'),
    //       meta: {
    //         title: '仓库缺货',
    //       },
    //       permissionType: 'tab',
    //       hidden: true,
    //     },
    //   ],
    // },
    /**  **** 商品缺货管理   Out ****  */
    // {
    //   path: 'out',
    //   name: 'BusinessStockOut',
    //   component: EmptyRouter,
    //   redirect: 'out/list',
    //   meta: {
    //     title: '商品缺货管理',
    //   },
    //   children: [
    //     {
    //       path: 'list',
    //       name: 'BusinessStockOutList',
    //       component: () => import('@/views/center-business/stock/out/index'),
    //       meta: {
    //         title: '商品缺货管理',
    //       },
    //     },
    //     {
    //       path: 'add',
    //       name: 'BusinessStockOutAdd',
    //       component: () => import('@/views/center-business/stock/out/add'),
    //       meta: {
    //         title: '添加补货店铺',
    //         isCache: true,
    //       },
    //       hidden: true,
    //     },
    //   ],
    // },
    /** 商品缺货end */
    /** **** 商品分配管理 Distribution **** */
    {
      path: 'distribution',
      name: 'BusinessStockDistribution',
      component: EmptyRouter,
      redirect: 'distribution/qty',
      meta: {
        title: '商品分配管理',
      },
      children: [
        // 数量分配
        {
          path: 'qty',
          name: 'BusinessStockDistributionQtyIndex',
          component: () => import('@/views/center-business/stock/distribution/qty/index'),
          meta: {
            title: '仓位数量分配',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'qty/addSku',
          name: 'BusinessStockDistributionQtyAddSku',
          component: () => import('@/views/center-business/stock/distribution/qty/addSku'),
          meta: {
            title: '商品分配-仓位数量分配',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'qty/addWarehouse',
          name: 'BusinessStockDistributionQtyAddWarehouse',
          component: () => import('@/views/center-business/stock/distribution/qty/addWarehouse'),
          meta: {
            title: '批量分配-仓位数量分配',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'qty/edit',
          name: 'BusinessStockDistributionQtyEdit',
          component: () => import('@/views/center-business/stock/distribution/qty/edit'),
          meta: {
            title: '编辑仓位数量分配',
          },
          hidden: true,
        },
        {
          path: 'qty/view',
          name: 'BusinessStockDistributionQtyView',
          component: () => import('@/views/center-business/stock/distribution/qty/view'),
          meta: {
            title: '查看仓位数量分配',
          },
          hidden: true,
        },
        // 比例分配
        {
          path: 'ratio',
          name: 'BusinessStockDistributionRatioIndex',
          component: () => import('@/views/center-business/stock/distribution/ratio/index'),
          meta: {
            title: '仓位比例分配',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'ratio/addSku',
          name: 'BusinessStockDistributionRatioAddSku',
          component: () => import('@/views/center-business/stock/distribution/ratio/addSku'),
          meta: {
            title: '商品分配-仓位比例分配',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'ratio/addWarehouse',
          name: 'BusinessStockDistributionRatioAddWarehouse',
          component: () => import('@/views/center-business/stock/distribution/ratio/addWarehouse'),
          meta: {
            title: '批量分配-仓位比例分配',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'ratio/edit',
          name: 'BusinessStockDistributionRatioEdit',
          component: () => import('@/views/center-business/stock/distribution/ratio/edit'),
          meta: {
            title: '编辑仓位比例分配',
          },
          hidden: true,
        },
        {
          path: 'ratio/view',
          name: 'BusinessStockDistributionRatioView',
          component: () => import('@/views/center-business/stock/distribution/ratio/view'),
          meta: {
            title: '查看仓位比例分配',
          },
          hidden: true,
        },
        // 分仓计划
        {
          path: 'plan',
          name: 'BusinessStockDistributionPlanIndex',
          component: () => import('@/views/center-business/stock/distribution/plan/index'),
          meta: {
            title: '分仓计划',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'plan/add',
          name: 'BusinessStockDistributionPlanAdd',
          component: () => import('@/views/center-business/stock/distribution/plan/add'),
          meta: {
            title: '新建分仓计划',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'plan/edit',
          name: 'BusinessStockDistributionPlanEdit',
          component: () => import('@/views/center-business/stock/distribution/plan/edit'),
          meta: {
            title: '编辑分仓计划',
          },
          hidden: true,
        },
        {
          path: 'plan/view',
          name: 'BusinessStockDistributionPlanView',
          component: () => import('@/views/center-business/stock/distribution/plan/view'),
          meta: {
            title: '查看分仓计划',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockDistributionPlanIndex_Reset',
          meta: {
            title: '重置-分仓计划',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockDistributionPlanIndex_Discard',
          meta: {
            title: '作废-分仓计划',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockDistributionPlanIndex_Cancel',
          meta: {
            title: '取消-分仓计划',
          },
          hidden: true,
        },
      ],
    },
    /** 商品分配end */
    // #endif
    /**  **** 数据同步管理 Synchronization  ****  */
    {
      path: 'synchronization',
      name: 'BusinessStockSynchronization',
      component: EmptyRouter,
      redirect: 'synchronization/List',
      meta: {
        title: '数据同步管理',
      },
      children: [
        {
          path: 'list',
          name: 'BusinessStockSynchronization',
          component: () => import('@/views/center-business/stock/synchronization'),
          meta: {
            title: '数据同步管理',
            isCache: true
          },
        },
        {
          path: 'add',
          name: 'BusinessStockSynchronizationAdd',
          component: () => import('@/views/center-business/stock/synchronization/add'),
          meta: {
            title: '新建数据同步',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'detail',
          name: 'BusinessStockSynchronizationDetail',
          component: () => import('@/views/center-business/stock/synchronization/detail'),
          meta: {
            title: '数据同步详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessStockSynchronizationIndex_Pass',
          meta: {
            title: '审核通过',
          },
          hidden: true,
        },
      ],
    },
    /**  **** 库存预警触发  ****  */
    {
      path: 'inventoryWarning',
      name: 'BusinessStockInventoryWarning',
      component: EmptyRouter,
      redirect: 'inventoryWarning/index',
      meta: {
        title: '库存预警触发',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessStockInventoryWarning',
          component: () => import('@/views/center-business/stock/inventoryWarning'),
          meta: {
            title: '库存预警触发',
            isCache: true
          },
        },
      ],
    },
  ],
};
